import { Typography, Paper, Container, Grid } from "@mui/material";
import file1 from './SAFEPATH-IIT.xlsx';
import file2 from './SAFEPATH-IIT_editable.xlsx';
import file3 from './SAFEPATH Practitioner\'s Guide.pdf';
import picture1 from './SAFEPATH IIT editable.png';
import picture2 from './SAFEPATH IIT .png';
import picture3 from './Practitioner\'s guide.png'
import { Button } from 'react-bootstrap';


function Downloads() {
  return (
    <Container>
      <Paper sx={{ padding: 4 }}>
        <Typography marginBottom={2} variant='h4'>Downloads</Typography>

        <Typography >
        <Grid container spacing={2}>
        <Grid item xs={5}>
        <a
        href={file3}
        download="practitioner's guide"
        target="_blank"
        rel="noreferrer"
      >
        <Button><img style={{ width: 400, height: 225 }}src={picture3} alt="picture3"/></Button>
      </a>
      <b>Practitioner's guide to Safe Smart Highways</b>
          
      </Grid>
      <Grid item xs={5}>
      <a
        href={file1}
        download="SAFEPATH-IIT"
        target="_blank"
        rel="noreferrer"
      >
       
      <Button><img style={{ width: 400, height: 225 }}src={picture2} alt="picture2"/></Button> 
      </a>
      <b>SAFEPATH - IIT (Impact indicator Tool)</b>
      
      </Grid>
      
      </Grid>
        </Typography>
      </Paper>
    </Container>
  )
}
export default Downloads;